import { InjectionToken } from '@angular/core';

export const CMS_CONSENT_ENABLED: InjectionToken<boolean> = new InjectionToken('CMS_CONSENT_ENABLED');
